import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { scrollToAnchor } from '../../utils/scroll';
type TocItem = {
  id: string;
  title: string;
};
type ArticleTocProps = {
  items: TocItem[];
  activeId?: string;
};
export function ArticleToc({
  items,
  activeId
}: ArticleTocProps) {
  return <nav aria-label="In this article" data-id="element-120" data-mp="oft50x8kmr3g">
      <p className="text-[13px] font-semibold text-ink" data-id="element-121" data-mp="oeructvgw6m9">In this article</p>
      <TocList items={items} activeId={activeId} className="mt-3 border-l border-canvas-line" data-id="element-122" data-mp="jgyltu6oz0it" />
    </nav>;
}
export function MobileArticleToc({
  items,
  activeId
}: ArticleTocProps) {
  const [open, setOpen] = useState(false);
  return <nav aria-label="In this article" className="rounded-[12px] border border-canvas-line bg-white lg:hidden" data-id="element-123" data-mp="alipn6igs9a2">
      <button type="button" aria-expanded={open} aria-controls="article-toc-mobile" onClick={() => setOpen(o => !o)} className="flex h-12 w-full items-center justify-between px-4 text-[15px] font-semibold text-ink" data-id="element-124" data-mp="pfn3zjpa8ml">
        In this article
        <ChevronDownIcon className={`h-4 w-4 text-ink-muted transition-transform duration-200 ease-out ${open ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-125" data-mp="3tod9sbgx64gc" />
      </button>
      {open && <div id="article-toc-mobile" className="border-t border-canvas-line px-2 py-2" data-id="element-126" data-mp="3or4s0bzoo2fm">
          <TocList items={items} activeId={activeId} onSelect={() => setOpen(false)} data-id="element-127" data-mp="3oos8vvi6vm0z" />
        </div>}
    </nav>;
}
function TocList({
  items,
  activeId,
  className = '',
  onSelect
}: ArticleTocProps & {
  className?: string;
  onSelect?: () => void;
}) {
  return <ol className={className} data-id="element-128" data-mp="6cvu4lw4mw29">
      {items.map(item => {
      const active = item.id === activeId;
      return <li key={item.id} data-id="element-129" data-mp="be1kwe688995">
            <a href={`#${item.id}`} aria-current={active ? 'location' : undefined} onClick={e => {
          e.preventDefault();
          scrollToAnchor(item.id);
          onSelect?.();
        }} className={`-ml-px block border-l-2 py-1.5 pl-3.5 text-[14px] leading-[1.45] transition-colors duration-150 ease-out ${active ? 'border-brand font-medium text-ink' : 'border-transparent text-ink-muted hover:text-ink'}`} data-id="element-130" data-mp="2r33c8fhwtwcd">
              {item.title}
            </a>
          </li>;
    })}
    </ol>;
}